"use strict";

var _slicedToArray = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/slicedToArray");

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var _createTransitionContext = require("../context/createTransitionContext");

function TransitionObserver(props) {
  var innerRef = (0, _react.useRef)(null);
  var context = (0, _react.useContext)(_createTransitionContext.publicContext);

  var _ref = (0, _react.useState)(null),
      _ref2 = _slicedToArray(_ref, 2),
      contextState = _ref2[0],
      updateContextState = _ref2[1];

  var _ref3 = (0, _react.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      observing = _ref4[0],
      setObserving = _ref4[1];

  var observerSupport = 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
  (0, _react.useEffect)(function () {
    if (innerRef && innerRef.current) {
      var observer;
      var options = {
        threshold: 1
      };
      observer = new IntersectionObserver(function (observed) {
        var _observed = _slicedToArray(observed, 1),
            thisObserved = _observed[0];

        setObserving(!!thisObserved.intersectionRatio);
      }, options);
      observer.observe(innerRef.current);
      return function () {
        return observer.unobserve(innerRef.current);
      };
    }
  }, [innerRef]);
  (0, _react.useEffect)(function () {
    if (!observerSupport || props.forceRender) {
      // always update the context if there is no intersection
      // observer support or if the prop forceRender is set to true
      updateContextState(context);
    } else if (observing) {
      updateContextState(context);
    }
  }, [context.transitionStatus, innerRef, observing]);
  return props.children(contextState, innerRef);
}

var _default = TransitionObserver;
exports.default = _default;